// import React from "react";
// import { useSelector } from "react-redux";
// import FeatureUnavailable from "./FeatureUnavailable";
// import { CircularProgress, Box } from "@mui/material";

// export default function AccessControl({ feature, children }) {
//   const loading = useSelector((state) => state.appConfig?.loading);
//   const appConfigData = useSelector((state) => state.appConfig.configData);

//   // --- 1. Show loader while fetching config ---
//   if (loading || !appConfigData) {
//     return (
//       <Box
//         sx={{
//           display: "flex",
//           justifyContent: "center",
//           alignItems: "center",
//           height: "50vh",
//         }}
//       >
//         <CircularProgress />
//       </Box>
//     );
//   }

//   // --- 2. Extract feature toggle ---
//   const featureToggle = appConfigData?.data?.featureToggle || {};

//   // --- 3. Check access ---
//   const isEnabled = featureToggle[feature] === true;

//   // --- 4. If disabled → show fallback screen ---
//   if (!isEnabled) {
//     return <FeatureUnavailable heading={feature} />;
//   }

//   // --- 5. Feature enabled → show the content ---
//   return <>{children}</>;
// }
import React from "react";
import { useSelector } from "react-redux";
import FeatureUnavailable from "./FeatureUnavailable";
import { CircularProgress, Box } from "@mui/material";

const isTrueLike = (value) =>
  value === true || value === 1 || value === "1" || value === "true";

const isFeatureEnabled = (featureToggle, feature) => {
  const normalizedFeature = String(feature || "").toLowerCase();
  if (!normalizedFeature || !featureToggle || typeof featureToggle !== "object") {
    return false;
  }

  // If exact key exists, trust it (prevents duplicate-case keys from overriding).
  if (Object.prototype.hasOwnProperty.call(featureToggle, feature)) {
    return isTrueLike(featureToggle[feature]);
  }

  return Object.keys(featureToggle).some(
    (key) =>
      key.toLowerCase() === normalizedFeature && isTrueLike(featureToggle[key])
  );
};

export default function AccessControl({ feature, children }) {
  const loading = useSelector((state) => state.appConfig?.loading);
  const appConfigData = useSelector((state) => state.appConfig?.configData);

  // getBenefitsAndFeatures also flips the same `loading` flag; only block UI while *app config* is not loaded yet.
  const configLoaded =
    appConfigData &&
    typeof appConfigData === "object" &&
    Object.keys(appConfigData).length > 0;

  if (loading && !configLoaded) {
    return (
      <Box
        sx={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          height: "50vh",
        }}
      >
        <CircularProgress />
      </Box>
    );
  }

  // SUPPORT BOTH STRUCTURES
  const featureToggle =
    appConfigData?.featureToggle ||
    appConfigData?.data?.featureToggle ||
    appConfigData?.data?.data?.featureToggle ||
    {};
  const isEnabled = isFeatureEnabled(featureToggle, feature);

  if (!isEnabled) {
    return <FeatureUnavailable heading={feature} />;
  }

  return <>{children}</>;
}
